import { TriggerRunStatus } from '../assistant';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_TRIGGER_RUN_STATUS = 'TRIGGER_RUN_STATUS_';

export const TriggerRunStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_TRIGGER_RUN_STATUS}${TriggerRunStatus.PENDING}`]: 'Programmée',
    [`${TRANSLATE_KEY_TRIGGER_RUN_STATUS}${TriggerRunStatus.SENT}`]: 'Envoyée',
    [`${TRANSLATE_KEY_TRIGGER_RUN_STATUS}${TriggerRunStatus.FAILED}`]: 'En échec',
    [`${TRANSLATE_KEY_TRIGGER_RUN_STATUS}${TriggerRunStatus.CANCELLED}`]: 'Annulée',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(TriggerRunStatus, TriggerRunStatusTranslation, TRANSLATE_KEY_TRIGGER_RUN_STATUS, true);
